import styled from 'styled-components';

export const RadioBlock = styled.div`
  .radio-row {
    padding: 5px;
    display: flex;
  }
`;
